import { BlurOnIcon } from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as layoutActions from '../layout/actions/layout.actions';
import { showDelineationSelector } from '../layout/selectors/layout.selectors';
import { ToolButton } from '../../features/tool/components/ToolButton';

export const ShowDelineation: React.FC = () => {
  const dispatch = useDispatch();
  const showDelineation = useSelector(showDelineationSelector);

  const handleToggle = useCallback(() => {
    dispatch(
      layoutActions.update({ update: { showDelineation: !showDelineation } }),
    );
  }, [dispatch, showDelineation]);

  return (
    <>
      <ToolButton
        label='Show / Hide Delineation'
        onClick={handleToggle}
        aria-label='Show / Hide Delineation'
        icon={<BlurOnIcon />}
        isActive={showDelineation}
      />
    </>
  );
};
